import { useTimeframe } from '../hooks/useTimeframe'
import { TIMEFRAMES, timeframeLabel } from '../lib/timeframe'
import './TimeframeSwitcher.css'

/**
 * Global measurement-window control (spec §4). One selector in the shell
 * governs every performance panel; panels where a window is meaningless
 * ignore it and state their own window in their caption.
 */
export function TimeframeSwitcher() {
  const { timeframe, setTimeframe } = useTimeframe()
  return (
    <div className="timeframe-switcher view-toggle" role="group" aria-label="Measurement window">
      {TIMEFRAMES.map((tf) => (
        <button
          key={tf}
          type="button"
          aria-pressed={timeframe === tf}
          className={timeframe === tf ? 'active' : ''}
          onClick={() => setTimeframe(tf)}
        >
          {timeframeLabel(tf)}
        </button>
      ))}
    </div>
  )
}
